
export enum WeightUomCd {
	KILOGRAMS = 'Kilograms',
	POUNDS = 'Pounds'}

